'use strict';

var PooledSeasonalityReviewToolbarDirective = function PooledSeasonalityReviewToolbarDirective() {
  return {
    restrict: 'E',
    template: require('../templates/pooled-seasonality-review-toolbar.html'),
    scope: {
      screenState: '='
    },
    controller: 'PooledSeasonalityReviewToolbarController',
    link: function link($scope) {
      $scope.$on('cog:pooled-seasonality-review-toolbar', $scope.flowTypeChange);
    }
  };
};
PooledSeasonalityReviewToolbarDirective.$inject = [];
module.exports = PooledSeasonalityReviewToolbarDirective;